export default __webpack_public_path__ + "static/github-labels-ab7ed1e8239146f310bb383e9a7a2d53.png";